import { Button, Row, Text } from '@findemdev/maui';
import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;  // Use the full height of the viewport
  background: ${({ theme }) => theme.colors['white']};
`;

export const LoginContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100vh;
  justify-content: space-between;

  > div:first-child {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  img {
    height: 100vh;
    width: 100%;
  }
`;

export const Logo = styled.img`
  height: 60px;
  margin-bottom: 20px;
`;

export const Divider = styled.div`
  width: 100%;
  text-align: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors['grey-200']};
  line-height: 0.1em;
  margin: 20px 0 20px;
`;

export const DividerText = styled.span`
  background: ${({ theme }) => theme.colors['white']};
  color: ${({ theme }) => theme.colors['grey-500']};
  padding: 0 10px;
`;

export const StyledRow = styled(Row)`
  margin: 64px 0px 32px 0px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const HeadMessage = styled.div`
  font-family: Roboto;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  margin-bottom: 10px;
`;

export const StyledButton = styled(Button)`
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const StyledSpan = styled.span`
  cursor: pointer;
`;

export const MutedSubTitle = styled(Text)`
  color: ${({ theme }) => theme.colors['grey-600']};
  font-size: 16px;
`;